/**
 * Foundation init
 */
$(document).foundation();

/**
 * Equalizer
 * Setup the same height for all selected elements
 */
$.fn.equalizer = function()
{
    // Reset height
    $(this).css('height', 'auto');

    // Get all heights
    var elementHeights = $(this).map(function() {
        return $(this).outerHeight();
    }).get();

    // Get max height
    var maxHeight = Math.max.apply(null, elementHeights);

    // Set max height to all elements
    $(this).css('height', maxHeight);
};

/**
 * Carousel
 */
$(function () {
    var carousel = new Swiper('.swiper-container', {
/*        nextButton: '.arrow--next',
        prevButton: '.arrow--prev',*/
        slidesPerView: 1,
    });

    var carouselMulti = new Swiper('.swiper-container-multiple', {
        nextButton: '.arrow--next',
        prevButton: '.arrow--prev',
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 3,
        initialSlide: 3,
        spaceBetween: 0,
        cssWidthAndHeight: true,
        visibilityFullFit: true,
        autoResize: false,
        slideToClickedSlide: true,
        coverflow: {
            rotate: 0,
            stretch: 0,
            depth: 500,
            modifier: 1,
            slideShadows : false,
        },
        breakpoints: {
            768: {
                slidesPerView: 4
            },
            500: {
                slidesPerView: 2,
            },
        }
    });

    var grass = new Swiper('.swiper-container-grass', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        calculateHeight: true,
        cssWidthAndHeight: true,
        visibilityFullFit: true,
        autoResize: false,
    });
});

// Smaller header
$(window).on('scroll', function() {
    var scroll = $(window).scrollTop();

    if(scroll >= 100) {
        $('.header').addClass('header--moved');
    } else {
        $('.header').removeClass('header--moved');
    }
});

// Fancybox
$('.videos__item').fancybox();
$('.products a').fancybox();

// Burger
$(window).on('load resize', function(){
    $('.header').removeClass('header--smaller');

    var li = $('.header li:first-child').outerHeight();
    var ul = $('.header ul').outerHeight();

    if(ul > li){
        $('.header').addClass('header--smaller');
    }
});

/**
 * Open
 */
$('.burger').on('click', function () {
    $(this).toggleClass('open');
    $('.header ul').toggleClass('open');
});

$(window).on('load resize', function () {
    $('.tabs__title').equalizer();
    $('.tabs li').equalizer();
    $('.products__item span').equalizer();
    $('.video  h6').equalizer();
    $('.shops  a').equalizer();
    $('.swiper-container .columns').equalizer();
});

$(document).on('click', '.swiper-slide .button--open', function () {
    $(this).click();
});

$(document).on('open.zf.reveal', function () {
    $('.shops  a').equalizer();
});

/**
 * Scroll
 */
 $(function() {
    var e = $(window);
    $(".scroll-section").on("click", function() {
        $("section").each(function() {
            var i = $(this).offset().top - 30;
            if (e.scrollTop() < i) return $("html, body").animate({
                scrollTop: i
            }, 1e3), !1
        })
    })
});
$(window).scroll(function () {
  var Bottom = $(window).height() + ($(window).scrollTop() + 400) >= $(document).height();
if(Bottom)
    {
        $('.scroll-section').fadeOut();
    } else {
        $('.scroll-section').fadeIn();
    }
});
